import {EResource} from "contracts/EResource";

export enum EGroupType {
    DEVICE = 'device',

    DEVICE_SENSOR = 'device_sensor',
    DRIVER = 'driver',
    VEHICLE = 'vehicle',
    USER = 'user',
    RECIPIENT = 'recipient',
    INDOOR_ASSET = 'indoor_asset',
    INDOOR_POSITION = 'indoor_position',
    REPORT = 'report',
}

export function getRouteForGroupType(groupType: EGroupType): string {
    switch (groupType) {
        case EGroupType.DEVICE:
            return 'devices';
        case EGroupType.DEVICE_SENSOR:
            return 'device-sensors';
        case EGroupType.DRIVER:
            return 'drivers';
        case EGroupType.VEHICLE:
            return 'vehicles';
        case EGroupType.REPORT:
            return 'reports';
        case EGroupType.INDOOR_ASSET:
            return 'indoor-assets';
        case EGroupType.INDOOR_POSITION:
            return 'indoor-positions';
    }

    return '/';
}

export function getGroupTypeName(groupType: EGroupType): string {
    switch (groupType) {
        case EGroupType.USER:
            return 'Users';
        case EGroupType.RECIPIENT:
            return 'Recipients';
        case EGroupType.DEVICE:
            return 'Devices';
        case EGroupType.DEVICE_SENSOR:
            return 'Sensors';
        case EGroupType.DRIVER:
            return 'Drivers';
        case EGroupType.VEHICLE:
            return 'Vehicles';
        case EGroupType.REPORT:
            return 'Reports';
        case EGroupType.INDOOR_ASSET:
            return 'Indoor Assets';
        case EGroupType.INDOOR_POSITION:
            return 'Indoor Positions';
    }
}

export function getGroupTypeForName(groupTypeName: string): EGroupType {
    switch (groupTypeName.toLowerCase()) {
        case 'device':
            return EGroupType.DEVICE;
        case 'device_sensors':
            return EGroupType.DEVICE_SENSOR;
        case 'driver':
            return EGroupType.DRIVER;
        case 'vehicle':
            return EGroupType.VEHICLE;
        case 'report':
            return EGroupType.REPORT;
        case 'indoor_asset':
            return EGroupType.INDOOR_ASSET;
        case 'indoor_position':
            return EGroupType.INDOOR_POSITION;
        case 'user':
            return EGroupType.USER;
        case 'recipient':
            return EGroupType.RECIPIENT;
    }

    return null;
}

export function getResourceForGroupType(groupType: EGroupType): EResource {
    switch (groupType) {
        case EGroupType.DEVICE:
            return EResource.DEVICES;
        case EGroupType.DEVICE_SENSOR:
            return EResource.DEVICE_SENSORS;
        case EGroupType.DRIVER:
            return EResource.DRIVERS;
        case EGroupType.VEHICLE:
            return EResource.VEHICLES;
        case EGroupType.REPORT:
            return EResource.REPORTS;
        case EGroupType.INDOOR_ASSET:
            return EResource.INDOOR_ASSETS;
        case EGroupType.INDOOR_POSITION:
            return EResource.INDOOR_LAYOUT;
    }
}

export function availableGroupTypes() {
    return [
        EGroupType.DEVICE,
        EGroupType.DRIVER,
        EGroupType.VEHICLE,
    ];
}


export function hasImplementedGrouping(groupType: EGroupType): boolean {
    return availableGroupTypes().includes(groupType);
}
